import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router';
// sections
import { JobCreateView, JobEditView } from 'src/sections/job2/view';

// ----------------------------------------------------------------------

export default function JobEditPage(props) {
  const { id: jobId } = useParams();
  return (
    <>
      <Helmet>
        <title> Hireintel - Edit Job</title>
      </Helmet>

      <JobCreateView jobId={jobId} />
    </>
  );
}
